/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptConfigurationsControllerCreateMutationResponse, PromptConfigurationsControllerCreate400, PromptConfigurationsControllerCreate401, PromptConfigurationsControllerCreate403 } from "../../models/promptConfigurationsController/PromptConfigurationsControllerCreate";

function getPromptConfigurationsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/prompt-configurations` as const }  
  return res
}

/**
 * @summary Create a new prompt configuration
 * {@link /api/v1/prompt-configurations}
 */
export async function promptConfigurationsControllerCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptConfigurationsControllerCreateMutationResponse, ResponseErrorConfig<PromptConfigurationsControllerCreate400 | PromptConfigurationsControllerCreate401 | PromptConfigurationsControllerCreate403>, unknown>({ method : "POST", url : getPromptConfigurationsControllerCreateUrl().url.toString(), ... requestConfig })  
  return res.data
}